import React from 'react'
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const NewsCardTwo = ({ item }) => {
    return (
        <Box
            sx={{
                backgroundColor: '#1e3a8a', // Koyu mavi arka plan
                borderRadius: '8px',
                overflow: 'hidden',
                mb: 4,
                position: 'relative',
                color: 'white',
                border: '2px solid #1e3a8a'
            }}
        >

            {/* Ana görsel/video alanı */}
            <Box
                sx={{
                    width: '100%',
                    height: '400px',
                    position: 'relative',
                    backgroundImage: `url(${item?.imageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    p: 3
                }}
            >
                {/* Kişi bilgileri - Sol üst */}
                {item?.person && (
                    <Box sx={{ mb: 'auto' }}>
                        <Typography 
                            sx={{ 
                                fontFamily: 'Poppins-Bold',
                                fontSize: '24px',
                                color: 'white',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                            }}
                        >
                            {item.person.name}
                        </Typography>
                        <Typography 
                            sx={{ 
                                fontFamily: 'Poppins-Regular',
                                fontSize: '14px',
                                color: 'white',
                                textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                            }}
                        >
                            {item.person.location}
                        </Typography>
                    </Box>
                )}
            </Box>

            {/* İçerik alanı */}
            <Box sx={{ p: 3 }}>
                {/* Ana başlık */}
                <Typography
                    sx={{
                        fontFamily: 'Poppins-SemiBold',
                        fontSize: '28px',
                        lineHeight: '36px',
                        color: '#fbbf24', // Altın sarısı
                        mb: 2
                    }}
                >
                    {item?.title}
                </Typography>

                {/* Tarih */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box
                        component="span"
                        sx={{
                            width: '16px',
                            height: '16px',
                            backgroundColor: '#fbbf24',
                            borderRadius: '2px',
                            mr: 1
                        }}
                    />
                    <Typography
                        sx={{
                            fontFamily: 'Poppins-Regular',
                            fontSize: '14px',
                            color: '#94a3b8'
                        }}
                    >
                        {item?.date}
                    </Typography>
                </Box>

                {/* Açıklama */}
                <Typography
                    sx={{
                        fontFamily: 'Poppins-Regular',
                        fontSize: '16px',
                        lineHeight: '24px',
                        color: 'white',
                        mb: 3
                    }}
                >
                    {item?.description}
                </Typography>

                {/* Action butonu */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {item?.category === 'activity' ? null : item?.category === 'workshop' && item?.downloadUrl ? (
                        <Button
                            component="a"
                            href={item.downloadUrl}
                            download
                            sx={{
                                border: '1px solid #fbbf24',
                                color: '#fbbf24',
                                fontFamily: 'Poppins-Medium',
                                fontSize: '14px',
                                px: 3,
                                py: 1,
                                borderRadius: '4px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#fbbf24',
                                    color: '#1e3a8a'
                                }
                            }}
                        >
                            Download PDF →
                        </Button>
                    ) : item?.category === 'workshop' && item?.externalUrl ? (
                        <Button
                            component="a"
                            href={item.externalUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                border: '1px solid #fbbf24',
                                color: '#fbbf24',
                                fontFamily: 'Poppins-Medium',
                                fontSize: '14px',
                                px: 3,
                                py: 1,
                                borderRadius: '4px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#fbbf24',
                                    color: '#1e3a8a'
                                }
                            }}
                        >
                            Visit Workshop →
                        </Button>
                    ) : item?.category === 'documents' && item?.downloadUrl ? (
                        <Button
                            component="a"
                            href={item.downloadUrl}
                            download
                            sx={{
                                border: '1px solid #fbbf24',
                                color: '#fbbf24',
                                fontFamily: 'Poppins-Medium',
                                fontSize: '14px',
                                px: 3,
                                py: 1,
                                borderRadius: '4px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#fbbf24',
                                    color: '#1e3a8a'
                                }
                            }}
                        >
                            Download PDF →
                        </Button>
                    ) : (
                        <Button
                            component={RouterLink}
                            to={`/news-detail/${item?.title?.toLowerCase()?.split(' ').join('-')}`}
                            sx={{
                                border: '1px solid #fbbf24',
                                color: '#fbbf24',
                                fontFamily: 'Poppins-Medium',
                                fontSize: '14px',
                                px: 3,
                                py: 1,
                                borderRadius: '4px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#fbbf24',
                                    color: '#1e3a8a'
                                }
                            }}
                        >
                            Continue Reading →
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default NewsCardTwo 